import { ToastMessageOptions } from 'primevue/toast'

/** A class for creating a custom Error instance. Adds a custom name to the error. */
export default class CustomError extends Error {
  public readonly toast?: ToastMessageOptions

  constructor(name: string, error: Error, toast?: ToastMessageOptions) {
    super(error.message)
    this.name = name
    this.toast = toast
    // in the rare case, that the stacktrace is not available , provide a fallback
    this.stack = error.stack || 'Stack trace not available'
  }
}
